import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money_s",
  "use": "icon-money_s-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-money_s\">\n<path d=\"M71.6,120v8h-16v-8c-17.6,0-32-14.4-32-32h16c0,8.8,7.2,16,16,16V72c-17.6,0-32-14.4-32-32S38,8,55.6,8V0h16v8\n\tc17.6,0,32,14.4,32,32h-16c0-8.8-7.2-16-16-16v32h3.2c5.6,0,12.8,3.2,18.4,8c6.4,5.6,11.2,14.4,11.2,24\n\tC103.6,105.6,89.2,120,71.6,120z M71.6,104c8.8,0,16-7.2,16-16s-7.2-16-16-16C71.6,72,71.6,104,71.6,104z M55.6,24\n\tc-8.8,0-16,7.2-16,16s7.2,16,16,16V24z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol